import React from "react";
import ConsultantBadge from "../ConsultantBadge";

const ConsultantCard = ({ consultant, serviceName, serviceDescription }) => {
  if (!consultant?.user?.name) {
    return null;
  }

  // If no serviceName provided, render just the badge (original behavior for tutoring)
  if (!serviceName) {
    return <ConsultantBadge consultant={consultant} />;
  }

  // Full card with service info (new behavior for business service form)
  return (
    <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-6 space-y-4 transition-all duration-300 hover:shadow-lg">
      {/* Service Info */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {serviceName}
        </h3>
        {serviceDescription && (
          <p className="text-sm text-gray-600 line-clamp-2">
            {serviceDescription}
          </p>
        )}
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100"></div>

      {/* Consultant Badge */}
      <ConsultantBadge consultant={consultant} />
    </div>
  );
};

export default ConsultantCard;
